interface LogoProps {
  size?: "default" | "xl";
}

export function Logo({ size = "default" }: LogoProps) {
  const cls = size === "xl" ? "logo logo--xl" : "logo";
  return (
    <div className={cls}>
      SEI<span>LAN</span>
    </div>
  );
}
